import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const userRole = localStorage.getItem('role');

    // Not logged in
    if (!userRole) {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    // Get allowed roles from route data
    const allowedRoles = route.data['roles'] as string[];

    // If no roles specified, allow all logged-in users
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    // Check if user's role is in the allowed list
    if (allowedRoles.includes(userRole)) {
      return true;
    }

    // Not authorized — show alert and redirect
    Swal.fire({
      icon: 'error',
      title: 'Access Denied',
      text: 'You do not have permission to access this page.',
      confirmButtonColor: '#B71C1C'
    });
    this.router.navigate(['/incidents']);
    return false;
  }
}
